import Smartphones from 'Todo/views/TodoUnreadEventsView/containers/Smartphones'
import Tablets from 'Todo/views/TodoUnreadEventsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TodoUnreadEventsView = getCurrentDeviceView(Smartphones, Tablets)

export default TodoUnreadEventsView
